import type { ColorItem } from '@octopus-do/octopus-project-core'
import cx from 'classnames'
import type React from 'react'
import { useState } from 'react'

import css from './ColorLibrary.module.scss'
import { ColorList } from './ColorList'

interface ColorPickerProps {
  colors: ColorItem[]
  // the palette is shown but takes no edits: no new color, no picker,
  // no rename, no reorder, no remove
  disabled?: boolean
  onMoveColor: (id: string, index: number) => void
  onChangeColor: (id: string, hexCode: string) => void
  onAddNewColor: () => void
  onRemoveColor: (id: string) => void
  onRenameColor: (id: string, title: string) => void
  onSwitchColor: (id: string, showInLegend: boolean) => void
}

export const ColorLibrary: React.FC<ColorPickerProps> = ({
  colors,
  disabled = false,
  onChangeColor,
  onAddNewColor,
  onMoveColor,
  onRenameColor,
  onRemoveColor,
  onSwitchColor,
}) => {
  const [activeColorPicker, setActiveColorPicker] = useState({
    show: false,
    id: '',
  })

  const handleOnBlur = (id: string, title: string) => {
    onRenameColor(id, title)
  }

  const handleAddNewColor = () => {
    if (!disabled) {
      onAddNewColor()
    }
  }

  const handleRemoveColor = (id: string) => {
    onRemoveColor(id)
  }

  const handleSelectColor = (id: string, hexCode: string) => {
    onChangeColor(id, hexCode)
  }

  const handleMoveColor = (colorId: string, index: number) => {
    onMoveColor(colorId, index)
  }

  const handleSwitchColor = (id: string, showInLegend: boolean) => {
    onSwitchColor(id, showInLegend)
  }

  return (
    <div>
      <ColorList
        colors={colors}
        disabled={disabled}
        activeColorPicker={activeColorPicker}
        onBlur={handleOnBlur}
        onRemoveColor={handleRemoveColor}
        onColorPicker={setActiveColorPicker}
        onSelectColor={handleSelectColor}
        onMoveColor={handleMoveColor}
        onSwitchColor={handleSwitchColor}
      />

      <div
        className={cx(css.newColorBtn, { [css.disabled]: disabled })}
        onClick={handleAddNewColor}
      >
        <i className="fa fa-plus" />
        <span>New color</span>
      </div>
    </div>
  )
}
